module.exports = __webpack_public_path__ + "img/editor_empty.245ddb6a.svg";